import { RouteConfig } from 'vue-router';

import { Rules as CaslRules } from '../../../back/src/casl/casl.constants';

import AmostrasCatalisadoresIndexProducao from '@/pages/amostras-catalisadores/AmostrasCatalisadoresIndexProducao.vue';
import AmostrasCatalisadoresDisplay from '@/pages/amostras-catalisadores/AmostrasCatalisadoresDisplay.vue';

const routes: RouteConfig[] = [
  {
    path: '/catalisadores/producao',
    name: 'AmostrasCatalisadoresIndexProducao',
    component: AmostrasCatalisadoresIndexProducao,
    meta: {
      icon: 'mdi-inbox-arrow-down',
      rules: [CaslRules.AmostraCatalisador.listarProducao],
    },
  },
  {
    path: '/catalisadores/painel',
    name: 'AmostrasCatalisadoresDisplay',
    component: AmostrasCatalisadoresDisplay,
    meta: {
      icon: 'mdi-monitor-screenshot',
      layout: 'Display',
      public: true,
    },
  },
];

export default routes;
